<template>
    <div v-if="wideScreen" style="overflow: hidden; padding: 10px; padding-left: 0 !important">
        <div
            id="chat-stats"
            :class="{
                'd-flex': true,
                'text-white': true,
                darkmode: isDarkMode,
                open: isOpen,
            }"
        >
            <div id="hide-noise">
                <a-popover
                    v-model:visible="statisticVisible"
                    placement="bottom"
                    trigger="click"
                    overlayClassName="chat-stats-popover"
                >
                    <template #content>
                        <div
                            class="system-statistic child"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.total')"
                        >
                            <div class="value">
                                {{ stats.totalActive }}
                            </div>
                            <div class="content">{{ $t("message.totalBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic child"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.total')"
                        >
                            <div class="value">
                                {{ isAdmin ? 0 : activeConversations.length }}
                            </div>
                            <div class="content">{{ $t("message.activeBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic child"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.waiting')"
                        >
                            <div class="value">
                                {{ stats.waiting }}
                            </div>
                            <div class="content">{{ $t("message.waitingBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic child"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.late')"
                        >
                            <div class="value">
                                {{ stats.late }}
                            </div>
                            <div class="content">{{ $t("message.lateBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic child"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.free')"
                        >
                            <div class="value">
                                {{ stats.free }}
                            </div>
                            <div class="content">{{ $t("message.freeBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic child"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.chatbot')"
                        >
                            <div class="value">
                                {{ stats.chatbot }}
                            </div>
                            <div class="content">{{ $t("message.chatbotChatCount").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic child"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.chatbot')"
                        >
                            <div class="value">
                                {{ systemMaxChatCapacity }}
                            </div>
                            <div class="content">{{ $t("message.maxCapacityBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic child"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.pco')"
                        >
                            <div class="value">
                                {{ Math.round(activeAgentRate) + "%" }}
                            </div>
                            <div class="content">{{ $t("message.pco").toUpperCase() }}</div>
                        </div>
                    </template>
                    <div @mouseover="stopAnimation" @click="visibleStatistic" @mouseleave="startAnimation">
                        <div
                            class="system-statistic animation"
                            v-show="animationItem == 0"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.maxCapacity')"
                        >
                            <div class="value">
                                <a-progress type="circle" :percent="Math.round(activeAgentRate)" :strokeWidth="10" />
                            </div>
                            <div class="content">{{ $t("message.pco").toUpperCase() }}</div>
                        </div>
                        <div
                            class="system-statistic animation"
                            v-show="animationItem == 1"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.total')"
                        >
                            <div class="value">{{ stats.totalActive }}</div>
                            <div class="content">{{ $t("message.totalBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic animation"
                            v-show="animationItem == 2"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.active')"
                        >
                            <div class="value">{{ isAdmin ? 0 : activeConversations.length }}</div>
                            <div class="content">{{ $t("message.activeBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic animation"
                            v-show="animationItem == 3"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.waiting')"
                        >
                            <div class="value">{{ stats.waiting }}</div>
                            <div class="content">{{ $t("message.waitingBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic animation"
                            v-show="animationItem == 4"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.late')"
                        >
                            <div class="value">{{ stats.late }}</div>
                            <div class="content">{{ $t("message.lateBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic animation"
                            v-show="animationItem == 5"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.free')"
                        >
                            <div class="value">{{ stats.free }}</div>
                            <div class="content">{{ $t("message.freeBg").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic animation"
                            v-show="animationItem == 6"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.chatbot')"
                        >
                            <div class="value">{{ stats.chatbot }}</div>
                            <div class="content">{{ $t("message.chatbotChatCount").toLocaleLowerCase() }}</div>
                        </div>
                        <div
                            class="system-statistic animation"
                            v-show="animationItem == 7"
                            v-tippy="{
                                followCursor: true,
                                placement: 'right',
                                theme: isDarkMode ? 'light-border' : 'google',
                            }"
                            :content="$t('stats.maxCapacity')"
                        >
                            <div class="value">{{ systemMaxChatCapacity }}</div>
                            <div class="content">{{ $t("message.maxCapacityBg").toLocaleLowerCase() }}</div>
                        </div>
                    </div>
                </a-popover>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";
import { log2 } from "../utils/log2";
import Arrows from "../components/svg/Arrows.vue";

const log = log2("ChatStats");
export default {
    name: "ChatStats",
    components: {
        Arrows,
    },
    data() {
        return {
            overdue: 0,
            isOpen: true,
            wideScreen: true,
            animationItem: 0,
            animationInterval: null,
            statisticVisible: false,
        };
    },
    methods: {
        ...mapActions({
            getDarkMode: "user/getDarkMode",
        }),
        detectWideScreen() {
            let width = document.body.clientWidth;
            if (width <= 1100) {
                //this.wideScreen = false;
            } else {
                //this.wideScreen = true;
            }
        },
        stopAnimation() {
            clearInterval(this.animationInterval);
            this.animationInterval = null;
        },
        startAnimation() {
            this.animationInterval = setInterval(() => {
                this.animationItem = this.animationItem < 7 ? this.animationItem + 1 : 0;
            }, 3000);
        },
        visibleStatistic() {
            this.stopAnimation();
            this.statisticVisible = true;
        },
    },
    computed: {
        ...mapState({
            conversations: (state) => state.chat.conversations,
            stats: (state) => state.chat.stats,
            settings: (state) => state.setting.settings,
            users: (state) => state.user.users,
            user: (state) => state.auth.user,
            data: (state) => state.chat.conversations.filter((c) => c.isOnline && c.status !== "destroyed"),
            isAdmin: (state) => state.auth.adminUser != null,
        }),
        ...mapGetters({
            activeConversations: "chat/getActiveConversations",
            activeAgentRate: "chat/activeAgentRate",
            systemMaxChatCapacity: "chat/systemMaxChatCapacity",
            isDarkMode: "user/isDarkMode",
        }),
    },
    mounted() {
        log("ChatStats mounted", this.conversations, this.isDarkMode);
        let i = 0;
        setInterval(() => {
            i += 1;
            const overdueChats = (this.overdue = this.conversations.filter(
                (c) =>
                    c.status === "new" &&
                    moment.duration(moment().diff(moment(c.createdDate))).asSeconds() > this.settings.overdueTime
            ));
            this.overdue = overdueChats.length;
        }, 1000);
        window.addEventListener("resize", this.detectWideScreen);
        this.detectWideScreen();
        this.startAnimation();
    },
};
</script>

<style lang="scss">
@keyframes moveUp {
    0% {
        transform: translateY(150%);
    }
    100% {
        transform: translateY(0);
    }
}

@keyframes moveDown {
    0% {
        transform: translateY(-150%);
    }
    100% {
        transform: translateY(0);
    }
}

#system-statistic,
.system-statistic {
    display: flex;
    color: black;
    font-size: 12px;
    align-items: center;
    padding: 4px 15px;
    border-radius: 10px;
    text-transform: capitalize;
    border: 1px solid #dddddd;
    cursor: pointer;
    overflow: hidden;
    height: 40px;
    width: 160px;

    .value {
        margin-right: 6px;
        font-weight: bold;
        font-size: 16px;
    }

    .ant-progress-inner {
        width: 30px !important;
        height: 30px !important;
    }

    .ant-progress-text {
        font-size: 10px;
        font-weight: bold;
    }

    &.child {
        margin-bottom: 4px;
        border: none;
        box-shadow: 0 0 16px 0 #eee;
    }

    &.animation {
        .value {
            animation: moveUp 0.5s linear;
        }

        .content {
            animation: moveUp 0.5s linear;
        }
    }
}

.chat-stats-popover {
    .ant-popover-inner-content {
        padding: 0 !important;
    }
}

.new-theme {
    $green-color: #06a9f3;

    #chat-stats {
        padding-left: 30px;

        #hide-noise {
            display: flex;
        }

        .ant-statistic {
            margin-right: 5px;
            display: flex;
            align-items: center;
            flex-direction: row-reverse;
            padding: 6px 10px;
            border-radius: 8px;
            font-family: "Poppins";
            height: 30px;

            &-title {
                font-size: 10px;
                margin: 0;
                padding: 0;
                text-transform: capitalize;
                font-family: "Poppins";
            }

            &-content {
                margin-right: 10px;
                display: flex;
                align-items: center;

                &-value {
                    font-size: 16px;
                    font-family: "Poppins";

                    &-int {
                    }
                }
            }
        }
    }

    #chat-stats {
        transition: all 0.3s;
        transform: translateX(calc(-100% + 50px));

        &.open {
            transform: translateX(0);
        }
    }

    #arrows {
        cursor: pointer;
        transition: all 0.3s;
        transform: rotateY(180deg);

        &.open {
            transform: rotateY(0deg);
        }
    }
}
</style>
